import { Loader } from '../../Loader'
import { Mask } from '../../Mask'

export function PageLoader() {
  return (
    <Mask>
      <Loader />
    </Mask>
  )
}

export default PageLoader
